import React, { useEffect, useRef, useState } from 'react';
import { IconButton, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MaterialTable from 'material-table';
import {
   headerStyle,
   tableIcons,
   tableStyle,
} from '../../../configs/ui/TableConfig';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/pro-light-svg-icons/faTimesCircle';
import Axios from 'axios';
import { useSnackbar } from 'notistack';
import { LogToBackend } from '../../../configs/helpers/LogToBackend';
import dayjs from 'dayjs';
import LoadingPopup from '../../Loading/LoadingPopup';
import ErrorPopup from '../../Error/ErrorPopup';

const useStyles = makeStyles((theme) => ({
   paper: {
      // backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(2, 4, 3),
      // backgroundColor: "#fff",
      width: '75%',
      borderRadius: '7.5px',
      maxHeight: '95vh',
      overflow: 'auto',
   },
   role: {
      color: '#5858FA',
   },
   title: {
      color: '#6E6E6E',
   },
   large: {
      width: theme.spacing(8),
      height: theme.spacing(8),
   },
   header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignContent: 'center',
      alignItems: 'center',
      margin: theme.spacing(1, 0),
   },
   content: {
      margin: theme.spacing(0, 1),
      width: '100%',
   },
   headerL: {
      margin: theme.spacing(1),
   },
}));

function View(props) {
   const classes = useStyles();
   const [isLoading, setIsLoading] = useState(false);
   const [isError, setIsError] = useState({
      error: false,
      errorStatus: '',
      errorMessage: '',
   });
   const closeRef = useRef();
   const [data, setData] = useState(props.data);
   const [resp, setResp] = useState([]);
   const [innerTableData, setInnerTableData] = useState([]);
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();

   useEffect(() => {
      getData();
   }, []);
   const getData = () => {
      setIsLoading(true);
      Axios.get(
         `/GSB/dashboard/reward/GetStockTransactionList?EntryId=${data.entryId}`,
      )
         .then((response) => {
            setResp(response.data);
         })
         .catch((e) => {
            LogToBackend(e);
            setIsError({
               error: true,
               errorStatus: e.response.status,
               errorMessage: e.response.data.errorAppMessageTh
                  ? e.response.data.errorAppMessageTh
                  : 'เกิดข้อผิดพลาด',
            });
         })
         .finally(() => {
            setIsLoading(false);
         });
   };
   useEffect(() => {
      setTableData();
   }, [resp]);
   const setTableData = () => {
      if (resp.length > 0) {
         const dataForMap = resp;
         const formatted = dataForMap.map((value) => {
            return Object.assign(
               {},
               {
                  ...value,
               },
            );
         });
         setIsLoading(false);
         setInnerTableData(formatted);
      }
   };
   const refreshData = () => {
      getData();
   };
   if (isLoading) return <LoadingPopup />;
   if (isError.error)
      return (
         <ErrorPopup
            onClick={props.onClickClose}
            errorStatus={isError.errorStatus}
            errorMessage={isError.errorMessage}
         />
      );
   return (
      <Paper className={classes.paper}>
         <div className={classes.header}>
            <Typography variant={'h4'}>ประวัติคลังสินค้า</Typography>
            <IconButton
               className={classes.headerL}
               size={'small'}
               onClick={props.onClickClose}
               ref={closeRef}
            >
               <FontAwesomeIcon icon={faTimesCircle} />
            </IconButton>
         </div>
         <MaterialTable
            isLoading={isLoading}
            columns={[
               {
                  field: 'logId',
                  title: 'Log ID',
               },
               {
                  field: 'typeDesc',
                  title: 'ประเภท',
               },
               {
                  field: 'qty',
                  title: 'จำนวน',
                  type: 'numeric',
               },
               {
                  field: 'stockQty',
                  title: 'จำนวนสินค้า',
                  type: 'numeric',
               },
               {
                  field: 'remark',
                  title: 'หมายเหตุ',
               },
               {
                  field: 'timeLabel',
                  title: 'เวลา',
                  type: 'datetime',
                  render: (rowData) =>
                     dayjs(new Date(rowData.timeLabel)).format(
                        'DD/MM/BBBB  HH:mm',
                     ),
               },
            ]}
            data={innerTableData}
            options={{
               showTitle: false,
               headerStyle: headerStyle,
               actionsColumnIndex: -1,
               addRowPosition: 'first',
               actionsCellStyle: {
                  color: '#ccc',
               },
               padding: 'dense',
               pageSize: 5,
               pageSizeOptions: [5, 10, 25, 50, 100],
            }}
            localization={{
               body: {
                  editRow: { deleteText: 'ต้องการลบข้อมูลนี้ใช่หรือไม่?' },
               },
               header: { actions: 'ตัวจัดการ' },
            }}
            style={tableStyle}
            icons={tableIcons}
         />
      </Paper>
   );
}

export default View;
